import { ReactElement, ReactNode } from 'react';

export interface PanelProps {
  children: ReactNode;
  className?: string;
  id?: string;
  sm?: boolean;
  dataTestId?: string;
}

const PanelHeading = ({
  children,
  className,
  sm,
}: PanelProps): ReactElement<any> => {
  return (
    <div className="border-b border-gray-200 px-5 py-4 last:border-b-0 dark:border-gray-700">
      <h3
        className={`${
          sm ? 'text-lg' : 'text-2xl leading-tight'
        } font-medium text-gray-700 dark:text-gray-300 ${className}`}
      >
        {children}
      </h3>
    </div>
  );
};

const PanelBody = ({ className, children }: PanelProps): ReactElement<any> => (
  <div className={`flex flex-col gap-y-4 p-5 ${className}`}>{children}</div>
);

const PanelFooter = ({
  className,
  children,
}: PanelProps): ReactElement<any> => (
  <div
    className={`rounded-b-panel border-t border-gray-200 bg-gray-50 px-5 py-5 dark:border-gray-700 dark:bg-gray-700 ${className}`}
  >
    {children}
  </div>
);

export const Panel = ({
  children,
  className = '',
  id,
  dataTestId,
}: PanelProps): ReactElement<any> => (
  <div
    id={id}
    data-testid={dataTestId}
    className={`rounded-panel border-container-border border bg-white dark:bg-gray-800 ${className}`}
  >
    {children}
  </div>
);

Panel.Heading = PanelHeading;
Panel.Footer = PanelFooter;
Panel.Body = PanelBody;
